import React from "react";
import styled from "styled-components";
import { ChevronUp, ChevronDown } from "react-feather";

const ChevronButton = styled.div`
    background: #fff;
    border-radius: 30px;
    color: var(--primary-color);
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
`;

export const ExpandMobileMenu = ({ onClick, expanded }: { onClick: Function; expanded: boolean }) => {
    return (
        <ChevronButton>
            {expanded ? <ChevronDown onClick={() => onClick()} /> : <ChevronUp onClick={() => onClick()} />}
        </ChevronButton>
    );
};
